<template>
  <div class="wrap" :class="{ show: showVideo }">
    <video ref="videoRef">
      Видео не поддерживается вашим браузером
    </video>
    <div class="video-avater" v-if="!videoActive">
      <div v-if="frame.avatar" class="avatar" :style="{ backgroundImage: `url(${frame.avatar})`}" />
      <div v-else class="initials">{{ initials }}</div>  
    </div>
    <div class="video-username">{{ frame.username }}</div>
    <div class="video-status" v-if="frame.streamManager.remote">
      <div class="status-volume"> 
        <b-form-input class="range-control" v-model="volume" type="range" min="0" max="100"></b-form-input>
        <button @click="toggleMute" class="mute-button">
          <i class="material-icons">
            {{ !mute ? 'volume_up' : 'volume_off' }}
          </i>
        </button>
      </div>
      <div v-if="!hasAudio" class="status-bar">
        <i class="material-icons mic-off">mic_off</i>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    self: Boolean,
    frame: {
      lastName: String,
      firstName: String,
      streamManager: Object,
      username: String,
      speaking: Boolean,
      mute: Boolean,
      volume: Number,
      activeFrame: Boolean
    }
  },
  data: () => ({
    showVideo: false,
    mute: false,
    volume: 50,
    tempVolume: 50,
  }),
  watch: {
    volume(value) {
      this.mute = !+value;
      this.$refs.videoRef.volume = value / 100;
    }
  },
  methods: {
    toggleMute() {
      this.mute = !this.mute;
      if (this.mute) {
        this.tempVolume = this.volume;
        this.volume = 0;
      } else {
        this.volume = this.tempVolume;
      }
    },
  },
  computed: {
    streamId() {
      return this.frame.streamManager.stream.streamId;
    },
    videoActive() {
      return this.frame.streamManager.stream.videoActive;
    },
    hasAudio() {
      return this.frame.streamManager.stream.hasAudio;
    },
    audioActive() {
      return this.frame.streamManager.stream.audioActive;
    },
    initials() {
      return this.frame.lastName.charAt(0) + this.frame.firstName.charAt(0);
    },
  },
  async mounted() {
    const ref = this.$refs.videoRef;
    await this.frame.streamManager.addVideoElement(ref);
    ref.play();
    await new Promise(r => setTimeout(r, 1000));
    this.showVideo = true;
  },
};
</script>

<style scoped>
.wrap {
  opacity: 0;
}
.wrap.show {
  opacity: 1;
}
.vm-video-range {
  display: flex;
  width: 100%;
  align-items: center;
}
.vm-video-range i {
  margin: 12px;
  color: #fff;
}
input[type=range] {
  outline: 0;
}
input[type=range]::-webkit-slider-thumb {
  background-color: white;
}
.initials {
  background-color: #cecece;
  color: #696969;
  font-size: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.mute-button {
  outline: 0;
  background-color: transparent;
  color: #fff;
}
.video-avater {
  position: absolute;
  height: 128px;
  width: 128px;
  border-radius: 50%;
  background-color: black;
  overflow: hidden;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.avatar {
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.red,
.mic-off {
  color: rgb(192, 34, 34);
}
.wrap {
  position: relative;
  display: flex;
  justify-content: center;
  max-height: 100%;
  overflow: hidden;
}
.video-status {
  position: absolute;
  top: 3px;
  right: 3px;
}
.video-username {
  position: absolute;
  color: #fff;
  background-color: rgba(0, 0, 0, .7);
  top: 3px;
  left: 3px;
  padding: 3px 6px;
  font-size: 14px;
}
video {
  display: block;
  max-width: 100%;
  max-height: 100%;
  background-color: black;
}
.status-volume {
  display: flex;
}
.status-volume .range-control {
  width: 80px;
  margin-right: 1rem;
  display: none;
}
.status-volume:hover .range-control {
  display: block;
}
</style>